export const COOKIE_USER = '_USER';
export const COOKIE_USER_EXPIRES = 1;
export const COOKIE_USER_REMEMBER_EXPIRES = 30;
